/**
 * Where each role LANDS after sign-in — the role's working surface, not a
 * fork of the navigation (the sider is identical for everyone; landing is
 * about the first question each role asks in the morning).
 *
 * Production Head lands on Decisions (what awaits their verdict), Plant
 * Head on Plant Oversight (variance and delays, read-only) — both compact
 * homes composed from the owning pages' own components.
 */
export const roleHome = (role) => {
  switch (role) {
    case "Production Supervisor":
    case "Line Manager":
      return "/execution?tab=today";
    case "QA Reviewer":
    case "QA Manager":
    case "QA Head":
      return "/variance/inbox?status=pending_approval";
    case "Production Head":
      return "/home/decisions";
    case "Plant Head":
      return "/home/oversight";
    default:
      return "/";
  }
};
